import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import HRMappings from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/HrMappings';
import HrPositionMappingGrid from 'routes/HumanResourcesModule/Settings/HrPositionMapping/HrPositionMappingGrid';
import HrGradeGrid from 'routes/HumanResourcesModule/Settings/HrGrade/HrGradeGrid';
import { useTranslation } from 'react-i18next';
import { HrPage } from 'routes/HumanResourcesModule/components/ui/HrPage';
import HrPayComponentMappingGrid from 'routes/HumanResourcesModule/Settings/HrPayComponentMapping/HrPayComponentMappingGrid';

const StyGridsWrapper = styled(Box, {
    name: 'StyGridsWrapper',
})({
    display: 'flex',
    flexDirection: 'column',
    gap: '2em',
});

export default function HrSettings(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <HrPage title={t('humanResources.settings.title')}>
            <StyGridsWrapper>
                <HrPayComponentMappingGrid />
                <HrPositionMappingGrid />
                <HrGradeGrid />
                <HRMappings />
            </StyGridsWrapper>
        </HrPage>
    );
}
